export default __webpack_public_path__ + "static/media/differentPracticeManagment.1e7efb05.png";